import {
  isRequired,
  isNumber,
  isArraySizeAtLeast,
  isNonEmptyArray,
  isUniqArray,
  isNumberArray,
  isStringArray,
  type Validation,
} from './utils';

interface CollectionNameRef {
  name: string;
}

interface ProductVideo {
  url?: string;
}

interface ProductVariantInput {
  price: number | string;
}

interface ProductFormValues {
  [key: string]: unknown;
  newCollections: unknown[];
  availableCollections: CollectionNameRef[];
  videos: ProductVideo[];
  variants: ProductVariantInput[];
}

interface RowError {
  rowIndex: number;
  key: string;
  message: string;
}

const validations: Validation<ProductFormValues>[] = [
  ({ name }) => isRequired(name) || { name: 'Product name is required.' },
  // ({ description }) => isRequired(description) || { description: 'Product description is required.' },
  ({ price }) => isNumber(price) || { price: 'Price should be a valid number.' },
  ({ sizes }) => isNonEmptyArray(sizes) || { sizes: 'Sizes is required.' },
  ({ colors }) => isNonEmptyArray(colors) || { colors: 'Colors is required.' },
  ({ vendor }) => isRequired(vendor) || { vendor: 'Vendor is required.' },
  ({ collectionIds }) => (
    isNumberArray(collectionIds)
      && isUniqArray(collectionIds)
      && isArraySizeAtLeast(collectionIds, 1))
    || { collectionIds: 'Collection ids is invalid.' },
  ({ newCollections, availableCollections }) => (
    isStringArray(newCollections)
      && isUniqArray(newCollections)
      && newCollections.length
      ? !newCollections.some((ncn) => availableCollections.find((c) => c.name === ncn))
      : true)
    || { newCollections: 'New collection is invalid.' },
  ({ videos }) => {
    const filtered = videos.filter((v) => v.url);

    const result: { videos: RowError[] } = {
      videos: [],
    };

    // match patterns
    // youtu.be/{videoId}
    // youtube.com/watch/{videoId}
    // youtube.com/shorts/{videoId}
    // youtube.com/live/{videoId}
    filtered.forEach((v, idx) => {
      const match = v.url!.match(/\/\/youtu\.be(\/)([a-zA-Z0-9-_]*)/)
        || v.url!.match(/(?:watch|shorts|live)(\?v=|\/)?([a-zA-Z0-9-_]*)/);

      if (match) {
        return;
      }

      result.videos.push({
        rowIndex: idx,
        key: 'url',
        message: 'Video url only support YouTube',
      });
    });

    if (!result.videos.length) {
      return false;
    }
    return result;
  },
  // ({ tags }) => isNonEmptyArray(tags) || { tags: 'Tags is required.' },
  ({ variants }) => {
    if (!isNonEmptyArray(variants)) {
      return false;
    }
    const result: { variants: RowError[] } = {
      variants: [],
    };
    variants.forEach(({ price }, idx) => {
      if (isNumber(price)) {
        return;
      }
      result.variants.push({
        rowIndex: idx,
        key: 'price',
        message: '',
      });
    });
    if (!result.variants.length) {
      return false;
    }
    return result;
  },
];

const KEYS = [
  'name',
  'description',
  'price',
  'sizes',
  'colors',
  'variants',
  'customizations',
  'vendor',
  'collectionIds',
  // 'tags',
  'media',
];

export {
  validations,
  KEYS,
};
